import { apiClient } from '@/services/api'

// Multi-site (zones): the user picks a GloboGraphics site; its **sigla** is sent on
// every request via the x-globographics-site header (see services/api) and as the
// ?site= param on header-less <img> URLs. The picker (GET /sites/producao/:cod) lists
// ALL active sites and defaults the selection to the production's praça site — praça
// is a default, not a filter. A site is a DB entity keyed by sigla.

const SELECTED_SITE_KEY = '@socialcam/selected_site'

const state = () => ({
    mySites: [],
    selectedSiteSigla: localStorage.getItem(SELECTED_SITE_KEY) || null,
    loading: false,
})

const getters = {
    getterMySites: state => state.mySites,
    getterSelectedSiteSigla: state => state.selectedSiteSigla,
}

const actions = {
    // Picker feed for a production: ALL active sites, defaulting the selection to the
    // production's praça site (`isDefault`). Praça is a default, not a filter — the
    // user can still pick any other site.
    async fetchSitesForProducao({ commit, dispatch }, codProducao) {
        if (!codProducao) {
            commit('setMySites', [])
            dispatch('selectSite', null)
            return []
        }
        commit('setLoading', true)
        try {
            const { data } = await apiClient.get(`sites/producao/${codProducao}`)
            const sites = Array.isArray(data) ? data : []
            commit('setMySites', sites)
            const def = sites.find(s => s.isDefault) || sites[0] || null
            dispatch('selectSite', def ? def.sigla : null)
            return sites
        } finally {
            commit('setLoading', false)
        }
    },

    selectSite({ commit }, sigla) {
        commit('setSelectedSite', sigla)
        if (sigla == null) localStorage.removeItem(SELECTED_SITE_KEY)
        else localStorage.setItem(SELECTED_SITE_KEY, sigla)
    },
}

const mutations = {
    setMySites: (state, sites) => { state.mySites = sites },
    setSelectedSite: (state, sigla) => { state.selectedSiteSigla = sigla },
    setLoading: (state, v) => { state.loading = v },
}

export default { namespaced: true, state, getters, actions, mutations }
